const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'CORE_UI:FETCH_TYPES_SUCCESS': {
            return {
                ...state,
                types: {
                    ...state.types,
                    ...action.data,
                },
            };
        }

        case 'CORE_UI:FETCH_SEARCH_TYPES_SUCCESS': {
            const newState = {
                ...state,
                types: {
                    ...state.types,
                    search: action.data,
                },
            };
            return newState;
        }

        case 'CORE_UI:FETCH_TIMEZONE_SUCCESS': {
            return {
                ...state,
                types: action.data,
            };
        }

        default:
            return state;
    }
};
